module.exports = __webpack_public_path__ + "img/83_29.101a2425.png";